import React, { useState, useEffect } from 'react';
import data from '../data.json'; // Make sure the path is correct to your JSON file
import './Education.css';
import Timeline from '../components/Timeline';

const Education = () => {
  const [educationData, setEducationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Simulate fetching data from data.json
        setTimeout(() => {
          setEducationData(data.education);
          setLoading(false);
        }, 1000); // Simulate 1 second loading time

      } catch (error) {
        setError(error);
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error fetching data: {error.message}</div>;
  }

  return (
    <div className="education-container">
      <h2>Education</h2>
      <Timeline items={educationData} /> {/* Pass educationData to Timeline */}
    </div>
  );
};

export default Education;
